export enum PrivateRoutesTitles {
  ACCOUNT = 'Account',
  OVERVIEW = 'Overview',
  CONTACT = 'Contact Us',
  PRIVACY = 'Privacy',
  TERMS = 'Terms',
  PORTFOLIO = 'Portfolio',
  MESSAGES = 'Messages',
  SEND_MESSAGE = 'Send Message',
  SHOW_MESSAGE = 'View Message',
  PROFILE = 'Manage Profile',
  LOAN_HISTORY = 'Loan History',
  DOCUMENTS = 'Documents',
  INVESTMENT_OFFERINGS = 'Investment Offerings',
  CALCULATOR = 'Calculator',
  RESOURCES = 'Resources',
  TRUST = 'Trust Details',
  LOAN_DETAILS = 'Loan Details',
  CONSTRUCTION_TRUST = 'Construction Trust Details',
  PAYMENT = 'Make a Payment',
  REQUEST_DRAW = 'Request a Draw',
  REVIEW_DRAW = 'Review Draw Request',
  VIEW_ALL_DRAWS = 'All Draw Requests',
  CREATE_DRAW_MESSAGE = 'Create Draw Message',
  DRAW_REQUEST_MESSAGE = 'Draw Request Message',
  PAYMENT_RECEIPT = 'Payment Confirmation',
}
